export const DISPLAY_DATE_FORMAT = 'DD-MM-YYYY'; // Para mostrar en el frontend
export const DISPLAY_DATE_TIME_FORMAT = 'DD-MM-YYYY hh:mm a'; // Para mostrar en el frontend
export const DISPLAY_LOG_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'; // Para mostrar en logs / consolas
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD'; // Para enviar al backend
export const INVALID_DATE_MESSAGE = 'Fecha no válida';
